<template>
  <form
    id="contact-preferences-form"
    class="panel-body"
    @submit.prevent="saveContactPreferences(customer)"
  >
    <div
      v-for="(err, i) in formErrors"
      :key="i"
      class="text-danger"
      v-text="err"
    />

    <ul class="list-unstyled">
      <li v-if="editing">
        <label
          v-for="field in contactFields"
          :key="field.name"
        >
          <!-- eslint-disable vue/no-mutating-props -->
          <input
            v-model="customer[field.name]"
            type="checkbox"
          >&nbsp;&nbsp;{{ field.label }}
          <!-- eslint-enable vue/no-mutating-props -->
        </label>
      </li>
      <li v-else>
        <div
          v-for="field in contactFields"
          :key="field.name"
          class="form-group"
        >
          <span v-if="customer[field.name]">&#x2714;</span>
          <span v-else>&#x2718;</span>
          <label
            class="inline"
            v-text="field.label"
          />
        </div>
      </li>
    </ul>
    <input
      v-if="editing"
      type="submit"
      class="btn btn-primary pull-right"
      value="Submit"
    >
  </form>
</template>

<script>
import CustomerModel from '../../../models/customer';

const fields = {
  email: { name: 'contactable_email', label: 'Email' },
  sms: { name: 'contactable_sms', label: 'SMS' },
  phone: { name: 'contactable_phone', label: 'Phone' },
  post: { name: 'contactable_post', label: 'Post' },
};

export default {
  props: {
    customer: {
      type: CustomerModel,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formErrors: [],
    };
  },
  computed: {
    contactFields() {
      const filteredFields = [];

      if (this.customer.email) filteredFields.push(fields.email);
      if (this.customer.tel_mobile) filteredFields.push(fields.sms);
      if (this.customer.tel_phone || this.customer.tel_mobile) filteredFields.push(fields.phone);
      filteredFields.push(fields.post);

      return filteredFields;
    },
  },
  methods: {
    saveContactPreferences(customer) {
      this.formErrors = [];

      if (!this.customer.contactable_email && !this.customer.contactable_sms) {
        if (this.customer.email && this.customer.tel_mobile) {
          this.formErrors.push('Either Email or SMS must be selected as a contact method.');
        } else if (this.customer.email) {
          this.formErrors.push('Email must be selected as a contact method.');
        } else {
          this.formErrors.push('SMS must be selected as a contact method.');
        }
      }

      if (this.formErrors.length === 0) {
        customer.saveContactPreferences()
          .then(() => {
            this.$emit('updated');
            this.formErrors = [];
          });
      }
    },
  },
};
</script>

<style lang="scss">
    .contact-field input.form-control {
        display: inline !important;
        width: auto;
    }
</style>

<style type="text/scss" lang="scss" scoped="scoped">
    @import 'node_modules/bootstrap-sass/assets/stylesheets/bootstrap/variables';
    @media(min-width: $screen-xs-max) {
        #contact-preferences-form {
            ul {
                column-count: 2;
            }
        }
    }

    #contact-preferences-form {
        ul {
            margin-top: 10px;
        }
    }

    label.inline {
        display: inline !important;
    }
</style>
